import { HoverPopover } from "@/components/popover/HoverPopover";
import { Sidebar } from "@/components/sidebar";
import { type DropdownItem } from "@/components/sidebar/Dropdown";
import { twMerge } from "@/utils/twMerge";

import { getCollapsedButtonProps } from "./getCollapsedButtonProps";

import type { HintKey } from "@/store/HintsStore";

type Props = {
  icon: React.ReactNode;
  tooltipTitle: string;
  title?: string;
  isActive?: boolean;
  hintKey?: HintKey;
  items?: DropdownItem[];
  itemsRole?: "radio";
  children?: React.ReactNode;
  className?: string;
  contentClassName?: string;
};

export function CollapsedPopover({
  icon,
  tooltipTitle,
  title,
  isActive,
  hintKey = "list",
  items,
  itemsRole,
  children,
  className,
  contentClassName,
}: Props) {
  return (
    <HoverPopover
      placement="left-start"
      offset={17}
      label={title ?? tooltipTitle}
      className={twMerge("rounded-6 data-[open]:bg-sidebar-button-hover-inverted-bg", className)}
      itemsClassName="w-[270px]"
      items={items}
      itemsRole={itemsRole}
      toggleButtonComponent={
        <Sidebar.ToggleButton
          tooltipTitle={tooltipTitle}
          disableTooltip
          icon={icon}
          isActive={isActive}
          hintKey={hintKey}
          withArrow={false}
          {...getCollapsedButtonProps(true)}
        />
      }
    >
      {!items && (
        <div
          className={twMerge(
            "rounded-10 p-1.5 bg-gray-100 dark:bg-gray-900 relative",
            contentClassName,
          )}
        >
          {title && (
            <div className="font-mono text-xxs tracking-tight uppercase mb-1 ml-1 h-6 leading-6 select-none">
              {title}
            </div>
          )}
          {children}
        </div>
      )}
    </HoverPopover>
  );
}
